// extracted by mini-css-extract-plugin
export default {"container":"list_container__LyYTW","loader":"list_loader__NKjTa"};